import React from "react";
import SectionHeading from "./SectionHeading/SectionHeading";
import { Button } from "./ui/Button";
import { SessionUser } from "@/types/common";
import { useRouter } from "next/navigation";
import { articleService } from "@/services/articleService";
// import toast from "react-hot-toast";
// import { saveCurrentUrl } from "@/utils/utils";
import { useSnackbar } from "@/context/SnackbarContext";

export default function DownloadComponent({
  sessionUser,
  post_id,
  // wall_id,
  // post_Wall,
  attachment,
}: {
  sessionUser?: SessionUser;
  post_id?: number;
  // wall_id?: number;
  // post_Wall?: any;
  attachment?: any;
}) {
  const router = useRouter();
  const { showSnackbar } = useSnackbar();
  const handleDownload = async () => {
    if(!attachment){
      // toast.error("File not found!");
      showSnackbar({
        message: "File not found!",
        type: 'error',
      });
      return;
    }
    // console.log(
    //   " handleDownload post_id",
    //   post_id,
    //   "wall_id",
    //   wall_id,
    //   "post_Wall",
    //   post_Wall,
    //   // "attachment",
    //   // attachment,
    //   sessionUser
    // );
    const article_id = Number(post_id) || 0;
    if (
      !sessionUser?.subscriber_id ||
      !sessionUser?.user_email ||
      article_id <= 0
    ) {
      if (article_id <= 0) {
        return;
      }
      // Store the current page URL before redirecting to signup
      // saveCurrentUrl();
      router.push("/auth/signup");
      return;
    }
    if (
      sessionUser?.subscriber_id &&
      sessionUser?.user_email &&
      article_id > 0
    ) {
      try {
        await articleService.attachmentDownload({
          post_id: Number(article_id) || 0,
          // file_url: attachment,
          token: sessionUser?.token || localStorage.getItem("peoples_token") || "",
        });

        const response = await fetch(`${process.env.NEXT_PUBLIC_API_BASE_URL}/api/article/attachment?post_id=${encodeURIComponent(Number(article_id))}`,{
          method: "POST",
          headers: {
            "Content-Type": "application/octet-stream",
            "Authorization": `Bearer ${sessionUser?.token || localStorage.getItem("peoples_token") || ""}`,
          },
        });
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = attachment.split('/').pop() || 'file';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        // const response = await fetch(attachment, {
        //   method: "GET",
        //   headers: {
        //     "Content-Type": "application/octet-stream",
        //   },
        // });

        // const blob = await response.blob();
        // const blobUrl = window.URL.createObjectURL(blob);

        // const link = document.createElement("a");
        // link.href = blobUrl;
        // link.download = attachment.split("/").pop() || "download.png";
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        // window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error("Download error:", error);
        // Optionally show an error message to the user
      }
    }
  };
  return (
    <div className="w-full pt-8 flex flex-col relative">
      <div className="z-9 absolute left-0 right-0 -top-48 w-full h-96"></div>
      <div className="z-10">
        <SectionHeading
          title="Takeaway"
          bgColor="bg-orange/20"
          textColor="text-orange"
        />
        <div className="flex gap-2 items-center pb-6">
          <span className="text-3xl font-medium text-foreground">
            Download your research.
          </span>
        </div>
        <Button onClick={handleDownload}>Download Now</Button>
      </div>
    </div>
  );
}
